export const ACCESS_SUPERPOWERED_SEARCH = 'Access superpowered search';
export const GET_ACCESS_TO_SEARCH =
  'Find your work faster than ever. Search Assembly and across all of your work apps like never before.';
export const ADD_TO_CHROME = 'Add to Chrome';
export const ITS_FREE = "it's free!";
